<template>
	<div>
		<div class="uk-container">
			<div class="mainfilter" uk-sticky>
				<div class="mainfilter__item">
					<a href="#offcanvas-filter" uk-toggle>
						<img :src="url + '/themes/oprava/assets/img/ico-filter.svg'" alt="" uk-svg>
						<span class="uk-visible@s">Открыть фильтр</span>
						<span v-if="count">({{ count }})</span>
					</a>
				</div>
				<div class="mainfilter__item mainfilter__item--right">
					<span>Сортировать по:</span>

					<select name="sort" @change="applyFilter" class="uk-select" v-model="filter.sort">
						<option :value="['price','asc']">Цене &#8593;</option>
						<option :value="['price','desc']">Цене &#8595;</option>
						<option :value="['discount','asc']">Новизне</option>
						<option :value="['discount','desc']">Скидке</option>
					</select>
				</div>
			</div>
		</div>

		<div id="offcanvas-filter" uk-offcanvas="overlay:true" class="m-filter uk-dark">
			<div class="uk-offcanvas-bar">

				<h3>Выберите параметры
					<small>Фильтр по параметрам</small>
				</h3>
				<div class="mainfilter__clear" v-show="count"><button @click="onClearFilter"><span uk-icon='close'></span> Очистить фильтр</button></div>
				<ul uk-accordion="multiple:true" class="m-filter">
					<li class="uk-open">
						<a class="uk-accordion-title" href="#">Бренд</a>
						<div class="uk-accordion-content">
							<div class="m-filter__item">
								<label v-for="brand in items.brands"><input class="uk-checkbox" type="checkbox" :value="brand.id" v-model="filter.brands">
									<img v-if="brand.image" :src="brand.image.path" alt="">
									<span v-else>{{ brand.title }}</span>
								</label>
							</div>
						</div>
					</li>
					<li class="">
						<a class="uk-accordion-title" href="#">Пол</a>
						<div class="uk-accordion-content">
							<div class="m-filter__item">
								<label v-for="g in items.genders"><input class="uk-checkbox" type="checkbox" :value="g.id" name="genders" v-model="filter.genders"> {{ g.title }}</label>
							</div>
						</div>
					</li>
					<li class="">
						<a class="uk-accordion-title" href="#">Размеры</a>
						<div class="uk-accordion-content">
							<div class="m-filter__slide">
								<div class="m-filter__desc">Размер окуляра</div>
								<input type="text" class="js-ocular" name="ocular_size" value="" />
							</div>
							<div class="m-filter__slide">
								<div class="m-filter__desc">Размер переносицы</div>
								<input type="text" class="js-nose" name="nose_size" value="" />
							</div>
						</div>
					</li>

					<li class="">
						<a class="uk-accordion-title" href="#">Материалы</a>
						<div class="uk-accordion-content">
							<div class="m-filter__desc">Материал окуляра</div>
							<div class="m-filter__item">
								<label v-for="mat in items.materials"><input class="uk-checkbox" type="checkbox" :value="mat.id" v-model="filter.materials" name="materials"> {{ mat.title }}</label>
							</div>
							<div class="m-filter__divider"></div>
							<div class="m-filter__desc">Материал заушника</div>
							<div class="m-filter__item">
								<label v-for="mat in items.hook_materials"><input class="uk-checkbox" type="checkbox" :value="mat.id" v-model="filter.hook_materials" name="hook_materials"> {{ mat.title }}</label>
							</div>
						</div>
					</li>

					<li class="">
						<a class="uk-accordion-title" href="#">Форма окуляра</a>
						<div class="uk-accordion-content">
							<div class="m-filter__item">
								<label v-for="mat in items.ocular_forms"><input class="uk-checkbox" type="checkbox" :value="mat.id" name="ocular_forms" v-model="filter.ocular_forms"> {{ mat.title }}</label>
							</div>
						</div>
					</li>

					<li class="">
						<a class="uk-accordion-title" href="#">Вид ободка</a>
						<div class="uk-accordion-content">
							<div class="m-filter__item">
								<label v-for="mat in items.rim_types"><input class="uk-checkbox" type="checkbox" :value="mat.id" name="rim_types" v-model="filter.rim_types"> {{ mat.title }}</label>
							</div>
						</div>
					</li>

					<li class="">
						<a class="uk-accordion-title" href="#">Цвета</a>
						<div class="uk-accordion-content">
							<div class="m-filter__item">
								<label v-for="color in items.colors"><input class="uk-checkbox" type="checkbox" :value="color.id" v-model="filter.colors">
									<span class="m-filter__color" :style="'background-color:' + color.code"></span>
									<span>{{ color.title }}</span>
								</label>
							</div>
						</div>
					</li>

					<li class="">
						<a class="uk-accordion-title" href="#">Прочее</a>
						<div class="uk-accordion-content">
							<div class="m-filter__desc">Наличие страз</div>
							<div class="m-filter__item">
								<label><input class="uk-checkbox" type="checkbox" v-model="filter.has_rhinestones"> Есть стразы</label>
							</div>
						</div>
					</li>

				</ul>
				<div class="m-filter__button">
					<button class="uk-button uk-button-primary" @click="applyFilter">
						<img :src="url + '/themes/oprava/assets/img/ico-filter2.svg'" alt="">
						ПРИМЕНИТЬ ФИЛЬТР
					</button>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
  import UIkit from 'uikit'
  import { bus } from './bus.js'
  import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js'
  import ionRangeSlider from 'ion-rangeslider'

  export default {
    name: "side-filter",
    data() {
      return {
        filter: {},
        count: '',
	      os_slider: '',
	      rs_slider: ''
      }
    },
    props: {
      items: '',
      url: '',
      filtered: '',
      counted: ''
    },
    methods: {
      filterNull() {
        this.filter = {
          brands: [],
          genders: [],
          ocular_size: [],
          rim_size: [],
          materials: [],
          hook_materials: [],
          ocular_forms: [],
          rim_types: [],
          has_rhinestones: '',
          colors: [],
          sort: ['discount', 'asc']
        }
      },
      checkSliders() {
        if (this.filter.rim_size.length > 0) {
          this.rs_slider.update({
            from: this.filter.rim_size[0],
            to: this.filter.rim_size[1]
          });
        }
        if (this.filter.ocular_size.length > 0) {
          this.os_slider.update({
            from: this.filter.ocular_size[0],
            to: this.filter.ocular_size[1]
          });
        }
      },
      sliders() {
        let app = this;
        this.os_slider = $(".js-ocular").ionRangeSlider({
          type: "double",
          skin: "round",
          min: 37,
          max: 61,
          from: 37,
          to: 61,
          //hide_from_to: true,
          grid: false,
          onFinish(d) {
            app.filter.ocular_size = [d.from, d.to];
          }
        }).data("ionRangeSlider");
        this.rs_slider = $(".js-nose").ionRangeSlider({
          type: "double",
          skin: "round",
          from: 7,
          to: 24,
          min: 7,
          max: 24,
          grid: false,
          onFinish(d) {
            app.filter.rim_size = [d.from, d.to];
          }
        }).data("ionRangeSlider");
      },
	    onClearFilter(){
        bus.$emit('wait', true);
        let newUrl = '/?page=1';
        history.pushState('', '', newUrl);
        let app = this;
        $.request('onClearFilter', {
          success: function (data) {
            //... do something ...
            console.log(data);
            app.filterNull();
            app.checkSliders();
            app.count = null;

            bus.$emit('filterApplied', data);
            UIkit.offcanvas('#offcanvas-filter').hide();
            bus.$emit('wait', false);
            //this.success(data);
          },
          error: function (err) {
            console.log(err);
          }
        })
	    },
      applyFilter() {
        //console.log(this.filter);
        bus.$emit('wait', true);
        let newUrl = '/?page=1';
        history.pushState('', '', newUrl);
        let app = this;
        $.request('onApplyFilter', {
          data: this.filter,
          success: function (data) {
            //... do something ...
            console.log(data);
            app.count = data.total;

            bus.$emit('filterApplied', data);
            UIkit.offcanvas('#offcanvas-filter').hide();
            bus.$emit('wait', false);
            //this.success(data);
          },
          error: function (err) {
            console.log(err);
          }
        })
      }
    },
    mounted() {
      this.sliders();
      $('.uk-offcanvas-bar').mCustomScrollbar({
        theme: "minimal-dark",
        autoHideScrollbar: true,
        mouseWheel: {
          enable: true,
          axis: "y",
          scrollAmount: 300
        }
      });
      this.checkSliders();
    },
    created() {
      if (!this.filtered) {
        this.filterNull();
      } else {
        this.filter = this.filtered;
        this.count = this.counted;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// themes/oprava/src/js/components/commerce/side-filter.vue